import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSuspenseHITLClient } from './useHitlClient'
import { Conversation } from '@botpress/client'

export const useSetAssignee = ({
  workspaceId,
  botId,
  onSuccess,
  onError,
}: {
  workspaceId: string
  botId: string
  onSuccess?: () => void
  onError?: () => void
}) => {
  const queryClient = useQueryClient()
  const client = useSuspenseHITLClient({ botId, workspaceId })

  return useMutation({
    mutationFn: async ({
      workspaceMemberId,
      conversationId,
    }: {
      workspaceMemberId: string | null
      conversationId: string
    }) => {
      await client.updateConversation({
        conversationId,
        status: workspaceMemberId ? 'assigned' : 'pending',
        assignee: workspaceMemberId
          ? {
              workspaceMemberId,
            }
          : null,
      })

      return { conversationId, workspaceMemberId }
    },
    onSuccess: async ({ conversationId, workspaceMemberId }) => {
      queryClient.setQueryData<Conversation[]>(
        ['workspaces_', workspaceId, 'bots_', botId, 'conversations', 'hitl', null, null, 'all'],
        (prev) => {
          return prev?.map((conv: Conversation) =>
            conv.id === conversationId
              ? {
                  ...conv,
                  tags: {
                    ...conv.tags,
                    'hitl:status': workspaceMemberId ? 'assigned' : 'pending',
                    ...(workspaceMemberId && { 'hitl:assigneeWorkspaceMemberId': workspaceMemberId }),
                  },
                }
              : conv
          )
        }
      )

      await queryClient.invalidateQueries({
        queryKey: ['workspaces_', workspaceId, 'bots_', botId, 'conversations', 'hitl', null, null, 'all'],
      })
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    },
  })
}
